<div class="boost-info-container">
  <div class="close-header" (click)="onNoClick()">x</div>
  <div class="boost-icon-container">
    <image-loader-utils url="rocket" extraClasses="boost-svg"></image-loader-utils>
  </div>
  <div class="header-bold">{{ 'boost_bonus_modal_header' | translate }}</div>
  <div class="text-row">{{ 'boost_bonus_modal_4' | translate }}</div>

  <div class="boost-info-detail-container">
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_10' | translate }} {{ this._DataHelper.customerBoostBonusInfo.MinEventCount | oddFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_5' | translate }} {{ this._DataHelper.customerBoostBonusInfo.MinOddValue | oddFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_6' | translate }} {{ this._DataHelper.customerBoostBonusInfo.MaxOddValue | oddFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_7' | translate }} {{ this._DataHelper.customerBoostBonusInfo.MinAmount | balanceFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_8' | translate }} {{ this._DataHelper.customerBoostBonusInfo.MaxAmount | balanceFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_9' | translate }}
    </div>

    <div class="color-blue" (click)="openInNewTab('/article/terms-and-conditions')">
      {{ 'terms_and_conditions' | translate }}
    </div>
  </div>

  <ng-container *ngIf="data.isOpenButton && !this._DataHelper.boostBonusCheckBox; else disabledButton">
    <div class="button-container" (click)="setBoostCheckBox()">
      <div class="btn colored green save-changes-button confirm-button">
        <div class="btn-text">
          {{ 'boost_bonus_modal_1' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #disabledButton>
    <div class="disabled button-container">
      <div class="btn colored green save-changes-button confirm-button">
        <div class="btn-text">
          {{ 'boost_bonus_modal_1' | translate }}
        </div>
      </div>
    </div>
  </ng-template>
</div>
